import { ErrorResponseType, ValidationResultItem } from '../typings/common';

import { getErrorTitle } from './GraphqlErrorHelper/GraphqlErrorHelper';

export class NotSyncedError<T> {
    public data: T;

    constructor(data: T) {
        this.data = data;
    }
}

export class ApiMethodExecutingError {
    private error: Error;
    private errors: ValidationResultItem[];
    private warnings: ValidationResultItem[];
    private errorType: ErrorResponseType;

    constructor(
        message: string,
        errors: ValidationResultItem[] = [],
        warnings: ValidationResultItem[] = [],
        errorType: ErrorResponseType = ErrorResponseType.internal
    ) {
        this.error = new Error(message);
        this.errors = errors;
        this.warnings = warnings;
        this.errorType = errorType;
    }

    /**
     * @deprecated этот метод будет удален
     * вместо него следует использовать методы getErrors и getWarnings
     * для получения списка всех ошибок. И получить текст ошибки с помощью GraphqlErrorHelper.getErrorMessage
     */
    getMessage(): string {
        return this.error.message;
    }

    getTitle(): string {
        return getErrorTitle(this.errors[0]);
    }

    getNativeError(): Error {
        return this.error;
    }

    getErrors(): ValidationResultItem[] {
        return this.errors;
    }

    getType(): ErrorResponseType {
        return this.errorType;
    }

    getWarnings(): ValidationResultItem[] {
        return this.warnings;
    }
}
